const fixTabIndex = () => {
  document.querySelectorAll('[aria-hidden]').forEach(el => {
    const isHidden = el.getAttribute('aria-hidden') === 'true';
    el.querySelectorAll('a, input, button').forEach(child => {
      isHidden
        ? child.setAttribute('tabindex', '-1')
        : child.removeAttribute('tabindex');
    });
  });
};

fixTabIndex(); // run once on load

new MutationObserver(fixTabIndex).observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ['aria-hidden']
});